import React from "react";

function ComposeToolbar({className = "", onAction, onColorChange, onOpenAttachment, onVoiceToText, disabled, uploading, signatureList, composeSignatureId, onSignatureChange, defaultSignatureId, isListening, onPaste, showCcField, onToggleCc, showBccField, onToggleBcc }) {
  return (
    <div className="mail-compose-toolbar">
         <button
        title={isListening ? "Stop voice input" : "Start voice input"}
        type="button"
        onClick={onVoiceToText}
        disabled={disabled}
        className={isListening ? "voice-active" : ""}
      >
        <i className={`fa-solid ${isListening ? "fa-stop" : "fa-microphone"}`}></i>
      </button>
       <button title="Add attachment" type="button" onClick={onOpenAttachment} disabled={disabled || uploading}>
        <i className="fa-solid fa-paperclip"></i>
      </button>
       <button title="Paste from clipboard" type="button" onClick={onPaste} disabled={disabled}>
        <i className="fa-solid fa-paste"></i>
      </button>

      <button
        title={showCcField ? "Hide Cc" : "Show Cc"}
        type="button"
        onClick={() => onToggleCc?.(!showCcField)}
        disabled={disabled}
      >
        <i className="fa-solid fa-user-plus"></i>
      </button>

      <button
        title={showBccField ? "Hide Bcc" : "Show Bcc"}
        type="button"
        onClick={() => onToggleBcc?.(!showBccField)}
        disabled={disabled}
      >
        <i className="fa-solid fa-user-secret"></i>
      </button>

      <button title="Bold" type="button" onClick={() => onAction?.("bold")} disabled={disabled}>
        <i className="fa-solid fa-bold"></i>
      </button>
      <button title="Italic" type="button" onClick={() => onAction?.("italic")} disabled={disabled}>
        <i className="fa-solid fa-italic"></i>
      </button>
      <button title="Underline" type="button" onClick={() => onAction?.("underline")} disabled={disabled}>
        <i className="fa-solid fa-underline"></i>
      </button>

      <div className="mail-toolbar-divider" />

      <select className="mail-toolbar-select" onChange={(e) => onAction?.("fontName", e.target.value)} disabled={disabled}>
        <option value="">Font</option>
        <option value="Arial">Arial</option>
        <option value="Times New Roman">Times</option>
        <option value="Courier New">Courier</option>
        <option value="Georgia">Georgia</option>
        <option value="Verdana">Verdana</option>
      </select>

      <select className="mail-toolbar-select" onChange={(e) => onAction?.("fontSize", e.target.value)} disabled={disabled}>
        <option value="">Size</option>
        <option value="1">Small</option>
        <option value="3">Normal</option>
        <option value="5">Large</option>
        <option value="7">Huge</option>
      </select>

      <div className="mail-toolbar-divider" />

      <button title="Align left" type="button" onClick={() => onAction?.("justifyLeft")} disabled={disabled}>
        <i className="fa-solid fa-align-left"></i>
      </button>
      <button title="Align center" type="button" onClick={() => onAction?.("justifyCenter")} disabled={disabled}>
        <i className="fa-solid fa-align-center"></i>
      </button>
      <button title="Align right" type="button" onClick={() => onAction?.("justifyRight")} disabled={disabled}>
        <i className="fa-solid fa-align-right"></i>
      </button>

      <div className="mail-toolbar-divider" />

      <label className="mail-color-btn" title="Text color">
        <i className="fa-solid fa-palette"></i>
        <input type="color" onChange={onColorChange} disabled={disabled} />
      </label>

      <button title="Bulleted list" type="button" onClick={() => onAction?.("insertUnorderedList")} disabled={disabled}>
        <i className="fa-solid fa-list-ul"></i>
      </button>
      <button title="Numbered list" type="button" onClick={() => onAction?.("insertOrderedList")} disabled={disabled}>
        <i className="fa-solid fa-list-ol"></i>
      </button>

      <div className="mail-toolbar-divider" />

      <button
        title="Insert link"
        type="button"
        onClick={() => {
          const url = window.prompt("Enter link URL");
          if (url) {
            onAction?.("createLink", url);
          }
        }}
        disabled={disabled}
      >
        <i className="fa-solid fa-link"></i>
      </button>
      <button title="Remove formatting" type="button" onClick={() => onAction?.("removeFormat")} disabled={disabled}>
        <i className="fa-solid fa-eraser"></i>
      </button>

     
   

      <div className="mail-toolbar-divider" />

      <select
        className="mail-toolbar-select"
        value={composeSignatureId ?? ""}
        onChange={onSignatureChange}
        disabled={disabled}
        title="Select signature"
      >
        <option value="">No signature</option>
        {signatureList?.map((signature) => (
          <option key={signature.id} value={signature.id}>
            {signature.label}
            {String(signature.id) === String(defaultSignatureId) ? " (Default)" : ""}
          </option>
        ))}
      </select>

    </div>
  );
}

export default ComposeToolbar;
